import { BudgetScenarioPartnerLocationOption } from '@callmart/types';
import api from './index';

const BASE = '/budget-scenarios';

export interface ScenarioMinutePriceValue {
    locationId: number;
    label: string;
    month: string; // 'YYYY-MM-DD'
    monthlyValue: number; // percent, e.g. 3 = +3 %
}

export interface ScenarioMinutePriceValuesResponse {
    /** The scenario's `updatedAt` AS OF this read — the revision the form's next PATCH must send with THESE
     *  rows (see ScenarioContactValuesResponse.revision for why the scenario query cannot supply it). */
    revision: string;
    values: ScenarioMinutePriceValue[];
    availablePartnerLocations: BudgetScenarioPartnerLocationOption[];
}

/** `versionId` is the version the OPTION lists must describe — the DRAFT one while the detail form's
 *  Budget select is pointed elsewhere, so the pickers stay in step with the impact preview (which is
 *  already priced against that version). Omitted, the server answers from the scenario's stored one. */
export const getScenarioMinutePriceValues = async (
    scenarioId: number,
    versionId?: number
): Promise<ScenarioMinutePriceValuesResponse> => {
    return api.get(`${BASE}/${scenarioId}/minute-price-values`, { params: { versionId } }).then((res) => res.data);
};
